import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { getCurrentSlice } from 'utils';
import { UiCheckbox, UiIcon, UiTooltip } from 'ui-components';
import { useTranslation } from 'react-i18next';
import { StyledSentimentFilter } from './SentimentFilter.styles';

const _DATA = {
  positive: {
    id: 'positive',
    color: '#66CB9F',
    icon: 'happy',
  },
  neutral: {
    id: 'neutral',
    color: '#00B8D9',
    icon: 'normal',
  },
  negative: {
    id: 'negative',
    color: '#F16063',
    icon: 'unhappy',
  },
  undefined: {
    id: 'undefined',
    color: '#9CAEBB',
    iconSrc: 'emotion-not-sure',
  },
};

const SentimentFilterContent = ({ item, filter, submitOnContext }) => {
  const { t } = useTranslation();
  return (
    <div className='flex' key={item}>
      <UiCheckbox
        onChange={() => submitOnContext(item)}
        checked={filter.selectedValues?.[item]}
        disabled={filter?.isDisabled}
      />
      <div className={classNames('flex', filter?.isDisabled && 'muted')}>
        {_DATA?.[item]?.iconSrc ? (
          <UiIcon
            src={_DATA?.[item]?.iconSrc}
            size={20}
            className={classNames('ml-8', filter?.isDisabled && 'muted')}
          />
        ) : (
          <UiIcon
            icon={`ri-emotion-${_DATA?.[item]?.icon}-line`}
            color={_DATA?.[item]?.color}
            size={20}
            className={classNames('ml-8', filter?.isDisabled && 'muted')}
          />
        )}
        <span className={classNames(filter?.isDisabled && 'muted')}>
          {t(`filter:${_DATA?.[item]?.id}`)}
        </span>
      </div>
    </div>
  );
};

SentimentFilterContent.propTypes = {
  item: PropTypes.string.isRequired,
  filter: PropTypes.object.isRequired,
  submitOnContext: PropTypes.func.isRequired,
};

/**
 * فیلتر انتخاب جهت گیری مطالب
 */
export const SentimentFilter = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { componentName, parentPlatform, className } = props;

  const filter = useSelector((state) =>
    parentPlatform
      ? state[state.filterReducer.filtersContext].filters[parentPlatform][
          componentName
        ]
      : state[state.filterReducer.filtersContext].filters[componentName]
  );
  const reducerName = useSelector(
    (state) => state.filterReducer.filtersContext
  );

  const { setSelectedSentimentValues } = getCurrentSlice(reducerName);

  const submitOnContext = (id) => {
    dispatch(
      setSelectedSentimentValues({
        id,
        value: !filter.selectedValues?.[id],
        componentName,
        parentPlatform,
      })
    );
  };

  return (
    <StyledSentimentFilter>
      <div className={classNames('filter-sentiment', className)}>
        {Object.keys(_DATA).map((item) => {
          if (item === 'undefined') {
            return (
              <UiTooltip
                placement='left'
                title={t('filter:undefinedSentimentTooltip')}
              >
                <span style={{ width: 'fit-content' }}>
                  <SentimentFilterContent
                    key={item}
                    item={item}
                    filter={filter}
                    submitOnContext={submitOnContext}
                  />
                </span>
              </UiTooltip>
            );
          }
          return (
            <SentimentFilterContent
              key={item}
              item={item}
              filter={filter}
              submitOnContext={submitOnContext}
            />
          );
        })}
      </div>
    </StyledSentimentFilter>
  );
};

SentimentFilter.propTypes = {
  componentName: PropTypes.string.isRequired,
  parentPlatform: PropTypes.string,
  className: PropTypes.string,
};
